import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getToken, isAdmin } from '@/utils/auth'

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/portal'
    },
    {
        path: '/portal',
        name: 'Portal',
        component: () => import('../views/SystemPortal.vue'),
        meta: { title: '系统入口', standalone: true, public: true }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginView.vue'),
        meta: { title: '登录', public: true, standalone: true }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('../views/RegisterView.vue'),
        meta: { title: '注册', public: true, standalone: true }
    },
    {
        path: '/semesters',
        name: 'Semesters',
        component: () => import('../views/SemesterManagement.vue'),
        meta: { title: '学期管理' }
    },
    {
        path: '/teachers',
        name: 'Teachers',
        component: () => import('../views/TeacherManagement.vue'),
        meta: { title: '教师管理' }
    },
    {
        path: '/exams',
        name: 'Exams',
        component: () => import('../views/ExamManagement.vue'),
        meta: { title: '考试管理' }
    },
    {
        path: '/exam-seats',
        name: 'ExamSeats',
        component: () => import('../views/ExamSeatsManagement.vue'),
        meta: { title: '学生排考' }
    },
    {
        path: '/schedules/:examId',
        name: 'Schedules',
        component: () => import('../views/ScheduleManagement.vue'),
        meta: { title: '监考排考' },
        props: true
    },
    {
        path: '/statistics',
        name: 'Statistics',
        component: () => import('../views/WorkloadStats.vue'),
        meta: { title: '工作量统计' }
    },
    {
        path: '/grades',
        name: 'Grades',
        component: () => import('../views/GradeManagement.vue'),
        meta: { title: '成绩管理' }
    },
    {
        path: '/grade-analysis',
        name: 'GradeAnalysis',
        component: () => import('../views/GradeAnalysis.vue'),
        meta: { title: '成绩分析' }
    },
    {
        path: '/division',
        name: 'Division',
        component: () => import('../views/ClassDivisionList.vue'),
        meta: { title: '智能分班' }
    },
    {
        path: '/division/:workspaceId',
        name: 'DivisionWorkspace',
        component: () => import('../views/ClassDivisionWorkspace.vue'),
        meta: { title: '智能分班工作区' },
        props: true
    },
    {
        path: '/course-schedule',
        name: 'CourseSchedule',
        component: () => import('../views/CourseScheduleList.vue'),
        meta: { title: '智能排课' }
    },
    {
        path: '/course-schedule/:workspaceId',
        name: 'CourseScheduleWorkspace',
        component: () => import('../views/CourseScheduleWorkspace.vue'),
        meta: { title: '智能排课工作区' },
        props: true
    },

    {
        path: '/users',
        name: 'Users',
        component: () => import('../views/UserManagement.vue'),
        meta: { title: '用户管理', requiresAdmin: true }
    },
    {
        path: '/tutorial',
        name: 'Tutorial',
        component: () => import('../views/TutorialView.vue'),
        meta: { title: '使用教程' }
    },
    {
        path: '/exam-clock',
        name: 'ExamClock',
        component: () => import('../views/ExamClock.vue'),
        meta: { title: '监考时钟', standalone: true, public: true }
    },
    {
        path: '/score-query',
        name: 'ScoreQuery',
        component: () => import('../views/ScoreQueryManagement.vue'),
        meta: { title: '成绩查询发布' }
    },
    {
        path: '/query/:code',
        name: 'ScoreQueryPublic',
        component: () => import('../views/ScoreQueryPublic.vue'),
        meta: { title: '成绩查询', standalone: true, public: true }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const adminToken = getToken()
    const isPublic = !!to.meta.public

    if (!isPublic && !adminToken) {
        next('/login')
        return
    }

    if (to.path === '/login' && adminToken) {
        next('/portal')
        return
    }

    if (to.meta.requiresAdmin && !isAdmin()) {
        ElMessage.error('仅管理员可访问该页面')
        next(from.path && from.path !== '/login' ? from.path : '/portal')
        return
    }

    document.title = to.meta.title ? `${to.meta.title} - 爱教务智能教务系统` : '爱教务智能教务系统'
    next()
})

export default router
